import React from 'react';
import './Cases.css';
import VideoPresent from './VideoPresent/VideoPresent';

export default class CasesList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            junior_speakers: [],
            senior_speakers: [],
        }
    }

    componentDidMount() {
        fetch(
            "https://geekle.us/api/1.1/wf/api_1_get_eventspeakers?event_track=1678202679508x888264276280606700")
            .then((res) => res.json())
            .then((json) => {
                this.setState({
                    junior_speakers: json,
                });
            })

        fetch(
            "https://geekle.us/api/1.1/wf/api_1_get_eventspeakers?event_track=1694787268552x321824496486973440")
            .then((res) => res.json())
            .then((json) => {
                this.setState({
                    senior_speakers: json,
                });
            })
    }

    render() {
        return (
            <div className="cases" id='cases'>
                <VideoPresent speakersJunior={this.state.junior_speakers} speakersSenior={this.state.senior_speakers} />
            </div >
        );
    }
};